import styled from 'styled-components';

type OptionItemInputProps = {
  marginLeft?: number;
  indeterminate?: boolean;
  top?: number;
  marginTop?: number;
  cursor?: string;
};

export const OptionItemInput = styled.input.attrs({
  className: 'form-check-input',
})<OptionItemInputProps>`
  margin-left: ${(props) => props.marginLeft || 8}px !important;
  margin-right: 10px !important;
  margin-top: 1px !important;
  transform: scale(1.2);
  width: 12px;
  height: 12px;
  position: relative;
  cursor: ${(props) => props.cursor || 'default'};
  margin-top: ${(props) => props.marginTop || 4}px !important;
  top: ${(props) => props.top || 0}px;
  :disabled {
    border-color: rgba(118, 118, 118, 0.3);
    opacity: 1;

  ${(props) =>
    props.indeterminate &&
    `background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e") !important;`}
`;
